import { Link } from 'react-router-dom';
import { useProjectContext } from '@/project/ProjectContext';
import styles from './ProjectPickerEmpty.module.css';

type Props = {
  title: string;
  description: string;
  stepLabel?: string;
  /** Korte regel op projectkaart */
  cardHint?: string;
};

export function ProjectPickerEmpty({
  title,
  description,
  stepLabel = 'Stap 1 — Kies werkruimte',
  cardHint = 'Doorgaan in deze werkruimte',
}: Props) {
  const { projects, setSelectedProjectId } = useProjectContext();

  return (
    <div className={styles.wrap}>
      <header>
        <h1 className={styles.heroTitle}>{title}</h1>
        <p className={styles.heroLead}>{description}</p>
      </header>

      <section className={styles.stepPanel} aria-labelledby="project-picker-step">
        <p id="project-picker-step" className={styles.stepLabel}>
          {stepLabel}
        </p>
        <div className={styles.grid} role="list">
          {projects.map((p) => (
            <button
              key={p.id}
              type="button"
              role="listitem"
              className={styles.projectCard}
              onClick={() => setSelectedProjectId(p.id)}
            >
              <span className={styles.projectName}>{p.name}</span>
              <span className={styles.projectHint}>{cardHint}</span>
            </button>
          ))}
        </div>
      </section>

      <div className={styles.footerLinks}>
        <Link to="/app/projects">Projecten beheren</Link>
        <Link to="/app/settings">Instellingen</Link>
      </div>
    </div>
  );
}
